// utils/formatValue.js
export function formatMetric(value, {
    decimals = 1,
    unit = "",
    fallback = "--"
} = {}) {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return fallback;
    }

    const num = Number(value);

    if (!Number.isFinite(num)) {
        return fallback;
    }

    return `${num.toFixed(decimals)}${unit ? ` ${unit}` : ""}`;
}
